import React from 'react'
import UploadPanel from '../components/UploadPanel'
import SidebarLayout from '../components/SidebarLayout'

function UploadPage() {
  return (
    <SidebarLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div
          style={{
            backgroundColor: '#f1f5f9', // slate-100
            padding: '1rem 1.25rem',
            borderBottom: '1px solid #e2e8f0', // gray-200
            fontSize: '1.125rem', // text-lg
            fontWeight: 600,      // font-semibold
            color: '#0f172a',     // slate-900
            borderTopLeftRadius: '0.5rem',
            borderTopRightRadius: '0.5rem',
            textAlign: 'center'   // ⬅️ Center the text
            }}
        >
        Upload Insurance Documents
        
      </div>
      <div style={{ padding: '2rem' }}>
          <UploadPanel />
      </div>
    </div>
    </SidebarLayout> 
  )
}

export default UploadPage
